export default "__VITE_ASSET__h9O9NGBj__"